import {
  DirectedRoute, DirectedRouteApi, // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedZoneApi extends DirectedRouteApi {
  getDirectedRoutes (options?: any): AxiosPromise<Array<DirectedRoute>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getDirectedRoutes(undefined, optionsParam)
  }
}
